var $1aa4ade186550f72$exports = {};
$1aa4ade186550f72$exports = {
  "dragDescriptionKeyboard": "Stisknut\xEDm kl\xE1vesy Enter za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragDescriptionKeyboardAlt": "Stisknut\xEDm Alt + Enter zah\xE1j\xEDte p\u0159etahov\xE1n\xED.",
  "dragDescriptionLongPress": "Dlouh\xFDm stisknut\xEDm zah\xE1j\xEDte p\u0159etahov\xE1n\xED.",
  "dragDescriptionTouch": "Poklep\xE1n\xEDm za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragDescriptionVirtual": "Kliknut\xEDm za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragItem": function dragItem(args) {
    return "P\u0159et\xE1hnout ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "P\u0159et\xE1hnout ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybranou polo\u017Eku");
      },
      few: function few() {
        return "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybran\xFDch polo\u017Eek");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Stisknut\xEDm kl\xE1vesy Enter p\u0159et\xE1hn\u011Bte ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybranou polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Stisknut\xEDm Alt + Enter p\u0159et\xE1hn\u011Bte ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybranou polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Dlouh\xFDm stisknut\xEDm p\u0159et\xE1hnete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybranou polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Po stisknut\xED kl\xE1vesy Tab najd\u011Bte po\u017Eadovan\xFD c\xEDl a stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete nebo stisknut\xEDm kl\xE1vesy Esc akci zru\u0161te.",
  "dragStartedTouch": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Najd\u011Bte po\u017Eadovan\xFD c\xEDl a poklep\xE1n\xEDm p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dragStartedVirtual": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Najd\u011Bte po\u017Eadovan\xFD c\xEDl a kliknut\xEDm nebo stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dropCanceled": "P\u0159eta\u017Een\xED bylo zru\u0161eno.",
  "dropComplete": "P\u0159eta\u017Een\xED bylo dokon\u010Deno.",
  "dropDescriptionKeyboard": "Stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete nebo stisknut\xEDm kl\xE1vesy Esc akci zru\u0161te.",
  "dropDescriptionTouch": "Poklep\xE1n\xEDm p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dropDescriptionVirtual": "Kliknut\xEDm objekt p\u0159et\xE1hn\u011Bte.",
  "dropIndicator": "indik\xE1tor p\u0159eta\u017Een\xED",
  "dropOnItem": function dropOnItem(args) {
    return "P\u0159et\xE1hnout na ".concat(args.itemText);
  },
  "dropOnRoot": "P\u0159et\xE1hnout na",
  "endDragKeyboard": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "endDragTouch": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Poklep\xE1n\xEDm p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "endDragVirtual": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Kliknut\xEDm p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "insertAfter": function insertAfter(args) {
    return "Vlo\u017Eit za ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Vlo\u017Eit p\u0159ed ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Vlo\u017Eit mezi ".concat(args.beforeItemText, " a ").concat(args.afterItemText);
  }
};
export { $1aa4ade186550f72$exports as default };